import { Link } from "react-router-dom";
import StarRoundedIcon from "@mui/icons-material/StarRounded";
import StarBorderRoundedIcon from "@mui/icons-material/StarBorderRounded";
import { resolveMenuIcon } from "./iconRegistry";

/**
 * Resultados de búsqueda: lista PLANA con breadcrumb, para que encontrar un
 * módulo anidado no dependa de ir expandiendo categorías a mano. Es el
 * cambio de mayor impacto sobre "tiempo para encontrar un módulo".
 */
export function SearchResultsList({ results, isFavorite, onToggleFavorite, onSelectLeaf }) {
  if (results.length === 0) {
    return (
      <div className="px-4 py-10 text-center text-sm text-slate-500 dark:text-slate-400">
        Ningún módulo coincide con la búsqueda.
      </div>
    );
  }

  return (
    <ul className="px-1.5 py-1">
      {results.map(({ item, breadcrumb }) => {
        const Icon = resolveMenuIcon(item.icon);
        return (
          <li key={item.id}>
            <Link
              to={item.route}
              onClick={() => onSelectLeaf(item)}
              className="group flex items-center gap-2.5 rounded-lg px-2.5 py-2 hover:bg-slate-100/90 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-morado dark:hover:bg-white/10"
            >
              <span className="flex h-7 w-7 flex-shrink-0 items-center justify-center rounded-lg bg-slate-100 text-slate-500 group-hover:text-morado dark:bg-white/10 dark:text-slate-300">
                <Icon fontSize="small" />
              </span>
              <span className="min-w-0 flex-1">
                <span className="block truncate text-[12.5px] font-medium text-slate-700 dark:text-slate-100">{item.name}</span>
                {breadcrumb && (
                  <span className="block truncate text-[10.5px] text-slate-400 dark:text-slate-500">{breadcrumb}</span>
                )}
              </span>
              <button
                type="button"
                aria-label={isFavorite(item.id) ? `Quitar ${item.name} de favoritos` : `Agregar ${item.name} a favoritos`}
                onClick={(event) => {
                  event.preventDefault();
                  event.stopPropagation();
                  onToggleFavorite(item.id);
                }}
                className={`flex h-6 w-6 flex-shrink-0 items-center justify-center rounded-md focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-morado ${
                  isFavorite(item.id) ? "text-amber-500" : "text-slate-300 hover:text-amber-500 dark:text-slate-500"
                }`}
              >
                {isFavorite(item.id) ? <StarRoundedIcon fontSize="small" /> : <StarBorderRoundedIcon fontSize="small" />}
              </button>
            </Link>
          </li>
        );
      })}
    </ul>
  );
}
